import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessageWrappedInSpan } from '../../misc';

import AccountDownloadTileButton from './AccountDownloadTileButton';
import VoucherCodeDialog from '../dialogs/VoucherCodeDialog';

const AccountDownloadTileVoucher = ({ icon, textInSpan, values }) => {
  const [hasOpenedOptions, setHasOpenedOptions] = useState(false);
  const [voucherToOpen, setvoucherToOpen] = useState(0);
  const [isVoucherDialogOpen, setIsVoucherDialogOpen] =
    useState(false);

  const handlehasOpenedOptionsOptions = () => {
    if (values?.length > 1) {
      setHasOpenedOptions(true);
    } else {
      showVoucherDialog(0);
    }
  };

  const showVoucherDialog = (index) => {
    setvoucherToOpen(index);
    setHasOpenedOptions(false);
    setIsVoucherDialogOpen(true);
  };

  return (
    <>
      <AccountDownloadTileButton
        icon={icon}
        textInSpan={textInSpan}
        hasOpenedOptions={hasOpenedOptions}
        onClick={handlehasOpenedOptionsOptions}
        hasOptions={values?.length > 0}
        onCloseOptions={() => setHasOpenedOptions(false)}
      >
        {hasOpenedOptions && (
          <div className="dropdown">
            {values.map((downloadableElement, index) => {
              return (
                <button
                  onClick={() => showVoucherDialog(index)}
                  className="dropdown-item"
                >
                  <FormattedMessageWrappedInSpan
                    id="accountEventPage.products.orderId"
                    defaultMessage="Order ID"
                    className="dropdown-label"
                  />
                  <span className="dropdown-detail"> {downloadableElement.orderid}</span>
                </button>
              );
            })}
          </div>
        )}
      </AccountDownloadTileButton>
      
      <VoucherCodeDialog
        open={isVoucherDialogOpen}
        onClose={() => setIsVoucherDialogOpen(false)}
        voucher={values &&  values[voucherToOpen].vouchers[0]}
      />
    </>
  );
};

AccountDownloadTileVoucher.propTypes = {
  icon: PropTypes.object,
  textInSpan: PropTypes.object,
  values: PropTypes.array,
};

export default AccountDownloadTileVoucher;
